import Link from '@components/link';
import { Typography } from '@gurupay/gp-ui-library';
import useMessages from '@hooks/useMessages';
import { useTranslation } from 'react-i18next';

import { MessagesTable } from './MessagesTable';

const CURRENT_PAGE = 1;
const PAGE_LIMIT = 5;

interface MessagesProps {
	canSign: boolean;
}

export const Messages = ({ canSign }: MessagesProps) => {
	const { t } = useTranslation('', { keyPrefix: 'dashboard' });

	const { data, isLoading } = useMessages(CURRENT_PAGE, PAGE_LIMIT);

	const messages = data?.items ?? [];
	const hasMessages = Boolean(messages.length);

	return (
		<>
			{!isLoading && hasMessages && (
				<div className="flex w-full items-center justify-between">
					{!canSign && (
						<Typography className="font-medium text-neutral-800" level="small-text">
							{t('messages.title')}
						</Typography>
					)}

					<Link
						className="ml-auto h-5 text-brand-secondary-600 hover:text-neutral-950 hover:border-b transition"
						to="/messages"
					>
						{t('messages.allMessages')}
					</Link>
				</div>
			)}

			<MessagesTable isLoading={isLoading} messages={messages} />
		</>
	);
};
